module.exports = __webpack_public_path__ + "images/liinilaevad/ms-icon-150x150.png";